module.exports = __webpack_public_path__ + "img/ic-jydw-point.d073aedf.png";